import React from "react";

const CatalogHeader = ({ groups, currentGroupId, onClick, desktop = false }) => {
  const containerClass = desktop ? "catalog-nav catalog-nav-desktop" : "catalog-mob-header";
  const itemClass = desktop ? "catalog-nav-item" : "catalog-mob-header-item";
  const selectedClass = desktop ? " catalog-nav-item-selected" : " catalog-mob-header-selected";

  const divItems = groups.map((g) => (
    <button
      type="button"
      id={`group-${g.id}`}
      className={itemClass + (currentGroupId === g.id ? selectedClass : "")}
      onClick={() => onClick(g.id)}
      key={g.id}
    >
      {g.name}
    </button>
  ));

  return (
    <div className={containerClass} id="group-header">
      {divItems}
    </div>
  );
};

export default CatalogHeader;
